import React, { Component } from "react";
import { PageLayout } from "../../components/ui";
import { toastService } from "../../services/toastService";
import { Dropdown } from "primereact/dropdown";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { dateBodyTemplate } from "../../utils/columnTemplates";
import { Button } from "primereact/button";
import { SearchRequestBaseModel, SortOrderType } from "../../models/SearchRequestModel";
import ExtendedDataTable from "../../components/ExtendedDataTable";
import { dateFilterTemplate, numberFilterMatchModeOptions, stringFilterMatchModeOptions } from "../Paginator";
import { orchestratorApiService } from "../../services/api/Compliance/OrchestratorApiService";
import { AmountBlockStatuses, BankTransferOutgoing, BankTransferStatus, ReconciliationStatuses, ReviewStatuses } from "../../models/Orchestrator";
import { PagedResult } from "../../models/Result";
import ReviewPendingBankTransferModal from "./ReviewPendingBankTransferModal";

export enum BankTransfersListType {
    All,
    Pending,
}

interface ListBankTransfersOutgoingProps {
    listType: BankTransfersListType;
}

interface ListBankTransfersOutgoingState {
    isLoading: boolean;
    bankTransfers: BankTransferOutgoing[];
    viewBankTransferModal: boolean;
    selectedTransfer: BankTransferOutgoing | null;
    totalRecords: number;
}

export default class ListBankTransfersOutgoing extends Component<ListBankTransfersOutgoingProps, ListBankTransfersOutgoingState> {
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: ListBankTransfersOutgoingProps | Readonly<ListBankTransfersOutgoingProps>) {
        super(props);

        this.state = {
            isLoading: false,
            bankTransfers: [],
            viewBankTransferModal: false,
            selectedTransfer: null,
            totalRecords: 0,
        };
    }

    loadData = async (searchRequest: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });
        let bankTransfersResult: PagedResult<BankTransferOutgoing[]> | null = null;
        if (this.props.listType === BankTransfersListType.Pending) {
            bankTransfersResult = await orchestratorApiService.getPendingPaged(searchRequest);
        }
        if (this.props.listType === BankTransfersListType.All) {
            bankTransfersResult = await orchestratorApiService.getAllPaged(searchRequest);
        }

        this.setState({ isLoading: false });

        if (bankTransfersResult != null) {
            if (!bankTransfersResult?.success) {
                toastService.error(bankTransfersResult?.message);
                return;
            }

            this.setState({ bankTransfers: bankTransfersResult?.data, totalRecords: bankTransfersResult.totalCount });
        }
    };

    startReviewing = async (row: BankTransferOutgoing) => {
        this.setState({ viewBankTransferModal: true, selectedTransfer: row });
    };

    actionBodyTemplate = (row: BankTransferOutgoing) => {
        if (this.props.listType === BankTransfersListType.Pending) {
            return <Button label="Review" type="button" severity="warning" onClick={() => this.startReviewing(row)}></Button>;
        }
    };

    enumLabel = (enumType: Record<string, string | number>, value: string | number | null | undefined) => {
        if (value === null || value === undefined) {
            return "-";
        }

        if (typeof value === "string") {
            const numericValue = Number(value);
            if (!Number.isNaN(numericValue) && enumType[numericValue] !== undefined) {
                return enumType[numericValue].toString();
            }

            return typeof enumType[value] === "number" ? value : enumType[value]?.toString() ?? value;
        }

        return enumType[value as keyof typeof enumType] ?? value.toString();
    };

    freezeStateTemplate = (rowData: BankTransferOutgoing) => <span>{rowData.customerOutgoingFreezeActive ? "Active" : "Not Active"}</span>;

    statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        // const statusOptions = Object.keys(BankTransferStatus).map((key) => ({
        //     label: key,
        //     value: BankTransferStatus[key as keyof typeof BankTransferStatus],
        //   }));
        // const statusOptions = [
        //     { label: 'New', value: BankTransferStatus.New },
        //     { label: 'Initiated', value: BankTransferStatus.Initiated },
        //     { label: 'Pending Execution', value: BankTransferStatus.PendingExecution },
        //     { label: 'Rejected', value: BankTransferStatus.Rejected },
        //     { label: 'Canceled', value: BankTransferStatus.Canceled },
        //     { label: 'Executed', value: BankTransferStatus.Executed },
        //     { label: 'Rejected By Borika', value: BankTransferStatus.RejectedByBorika },
        //     { label: 'Returned To Customer', value: BankTransferStatus.ReturnedToCustomer },
        //   ];
        const statusOptions = [
            { label: "New", value: 0 },
            { label: "Initiated", value: 1 },
            { label: "Pending Execution", value: 2 },
            { label: "Rejected", value: 3 },
            { label: "Canceled", value: 4 },
            { label: "Executed", value: 5 },
            { label: "Rejected By Borika", value: 6 },
            { label: "Returned To Customer", value: 7 },
        ];

        return (
            <Dropdown
                value={options.value}
                options={statusOptions}
                onChange={(e) => options.filterCallback(e.value)}
                optionLabel="label"
                optionValue="value"
                filter
                showClear
                placeholder="Select Status"
                className="p-column-filter"
            />
        );
        // return <Dropdown value={options.value} options={this.state.users} onChange={(e) => options.filterCallback(e.value)} optionLabel="label" optionValue="value" filter showClear placeholder="Select Users" className="p-column-filter" />;
    };

    toggleModalView = () => {
        this.setState({ viewBankTransferModal: false });
        this.loadData({
            pageNumber: this.dataTable?.state.page!,
            pageSize: this.dataTable?.state.pageRowCount!,
            filters: [],
            sortings: [],
        });
    };

    render() {
        return (
            <PageLayout noTitle>
                            {this.state.viewBankTransferModal && (
                                <ReviewPendingBankTransferModal onHide={this.toggleModalView} bankTransfer={this.state.selectedTransfer!} />
                            )}
                                <ExtendedDataTable
                                    value={this.state.bankTransfers}
                                    totalRecords={this.state.totalRecords}
                                    onChange={this.loadData}
                                    loading={this.state.isLoading}
                                    ref={(ref) => (this.dataTable = ref)}
                                    defaultSortOrder={SortOrderType.Descending}
                                    defaultSortField="createDate"
                                >
                                    <Column {...({ alwaysVisible: true } as any)} header="ID" field="id" filterMatchModeOptions={numberFilterMatchModeOptions}></Column>
                                    <Column
                                        field="createDate"
                                        header="Date"
                                        {...({ alwaysVisible: true } as any)}
                                        body={dateBodyTemplate("createDate")}
                                        filterMatchModeOptions={numberFilterMatchModeOptions}
                                        dataType="date"
                                        filterElement={dateFilterTemplate}
                                    ></Column>
                                    <Column
                                        header="Sender Name"
                                        field="sourceUserCustomerName"
                                        {...({ alwaysVisible: true } as any)}
                                        body={(rowData: BankTransferOutgoing) => <span>{rowData.sender.entityName}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>
                                    <Column
                                        header="Beneficiary Name"
                                        field="beneficiaryCustomerName"
                                        {...({ alwaysVisible: true } as any)}
                                        body={(rowData: BankTransferOutgoing) => <span>{rowData.recipient.entityName}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>
                                    <Column header="Amount" field="amount" filterMatchModeOptions={numberFilterMatchModeOptions}></Column>
                                    <Column header="Currency" field="currency" filterMatchModeOptions={stringFilterMatchModeOptions}></Column>

                                    {/* <Column field="status"
                                                header="Status F"
                                                filterMatchMode="equals"
                                                filterField="status"
                                                filterMatchModeOptions={numberFilterMatchModeOptions}
                                                // filterMatchModeOptions={stringFilterMatchModeOptions}
                                                filterElement={this.statusFilterTemplate}
                                                body={(rowData: BankTransferOutgoing) => <span>{BankTransferStatus[rowData.status]}</span>}
                                        ></Column> */}

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Status"
                                        field="status"
                                        body={(rowData: BankTransferOutgoing) => <span>{this.enumLabel(BankTransferStatus, rowData.status)}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Review Status"
                                        field="reviewStatus"
                                        body={(rowData: BankTransferOutgoing) => <span>{this.enumLabel(ReviewStatuses, rowData.reviewStatus)}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Outgoing Freeze"
                                        field="customerOutgoingFreezeActive"
                                        body={this.freezeStateTemplate}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Amount Block"
                                        field="amountBlockStatus"
                                        body={(rowData: BankTransferOutgoing) => <span>{this.enumLabel(AmountBlockStatuses, rowData.amountBlockStatus)}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Reconciliation"
                                        field="reconciliationStatus"
                                        body={(rowData: BankTransferOutgoing) => <span>{this.enumLabel(ReconciliationStatuses, rowData.reconciliationStatus)}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    <Column
                                        hidden={!(this.props.listType === BankTransfersListType.All)}
                                        header="Payment Reference"
                                        field="flexCubePaymentReference"
                                        body={(rowData: BankTransferOutgoing) => <span>{rowData.flexCubePaymentReference}</span>}
                                        filterMatchModeOptions={stringFilterMatchModeOptions}
                                    ></Column>

                                    {/* 
                                         <Column
                                            hidden={ !(this.props.listType === BankTransfersListType.All)}
                                            header="Source of Funds"
                                            field="sourceOfFundsStatus"
                                            body={(rowData: BankTransferOutgoing) => <span>{SourceOfFundsStatus[rowData.sourceOfFundsStatus]}</span>}
                                            filterMatchModeOptions={stringFilterMatchModeOptions}>
                                        </Column>  */}

                                    {/* <Column
                                            hidden={ (this.props.listType === BankTransfersListType.All)}
                                            header="Risk Info"
                                            field="riskRulesInfo"
                                            body={(rowData: BankTransferOutgoing) => <span>{rowData.riskRulesInfo}</span>}
                                            filterMatchModeOptions={stringFilterMatchModeOptions}>
                                        </Column> */}

                                    {/* <Column field="endUserPhone" header="End User Phone" sortable filterMatchModeOptions={stringFilterMatchModeOptions}></Column>
                                        <Column field="endUserEmail" header="End User Email" sortable filterMatchModeOptions={stringFilterMatchModeOptions}></Column>
                                        <Column field="reason" header="Risk reason" filterMatchModeOptions={stringFilterMatchModeOptions}></Column>
                                        <Column
                                            header="Uploaded Files">
                                        </Column> */}

                                    <Column
                                        hidden={this.props.listType === BankTransfersListType.All}
                                        header=""
                                        body={this.actionBodyTemplate}
                                        headerStyle={{ width: "8em", textAlign: "center" }}
                                        bodyStyle={{ textAlign: "center", overflow: "visible" }}
                                    />
                                </ExtendedDataTable>
            </PageLayout>
        );
    }
}
